<template>
  <div id="content">  
    <section class="top">
      <div style="width: 15px;"></div>
      <div class="logo">
        <img class="logo1" src="../assets/logo1.png" />
        <img class="logo2" src="../assets/logo2.png" />
        <img class="logo3" src="../assets/logo3.png" />
        <img class="logo4" src="../assets/logo4.png" />
      </div>
      <div style="flex: 1;"></div>
      <div class="search notes-search">
        <div class="search-text-bg">
          <h2 >证书查询</h2>
        </div>
        <el-input placeholder="请输入证书编号" v-model="input"></el-input>
        <el-button 
          class="search-button" 
          type="primary" 
          icon="el-icon-search"
          @click="searchByNumber"
          >搜索</el-button
        >
      </div>
      <div style="flex: 1;"></div>
      <div class="top-bu">
        <template slot="title">我的工作台</template>
        <el-button
          @click="drawer = true"
          type="primary"
          round
          style="margin-left: 5px">
          我们的服务
        </el-button>
        <el-drawer :visible.sync="drawer" direction="ltr" size="500px">
          <h4>
            <img src="../assets/jc.png" style="width: 100%; height: 350px" />
          </h4>
          <div class="battery">
            <el-button @click="innerDrawer1 = true">电池检测</el-button>
            <el-drawer title="电池检测" :append-to-body="true" :before-close="handleClose" :visible.sync="innerDrawer1">
              <h4>
                <img src="../assets/dc1.jpg" style="width: 100%; height: 150px" />
              </h4>
              <h4 style="color: rgb(20, 97, 180); ">
                &nbsp;&nbsp;&nbsp;&nbsp;电池认证简介
              </h4>
              <p class="battery-p3" style="padding: 0 15px;">
                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                随着电子、信息及通讯等产品均朝向无线化、可携带化方向发展，对于产品的各项高性能组件也往“轻、薄、短、小”的目标迈进，电池做为最佳的电源供应得到了广泛的运用，但近年来全球性电池召回事件引发了国际市场对电池产品安全性的担忧;
                同时，各国的市场监督机构了加大了对电池产品的监管力度，使国内电池生产商面临提升产品品质的挑战。倍测检测近年来也逐渐加强了对电池测试方面的投入，完善了各种电池测试仪器，为客户提供全面电池测试和认证服务，确保电池的品质能满足国际标准要求。
                </br>
              </p>            
              <h4 style="color: rgb(20, 97, 180); ">
                &nbsp;&nbsp;&nbsp;&nbsp;产品覆盖范围
              </h4>
              <p class="battery-p3" style="padding: 0 15px;">
                一次电池 普通干电池、碱性锌锰电池、锂锰电池
                </br>
                锌银电池、锌空气电池、锂碘电池、二次镍电池 镍镉电池、镍氢电池…
                </br>
                手机锂电池 锂离子电池、锂聚合物电池、各种数码二次电池…
                </br>
                笔记本电脑电池、数码相机电池、摄像机电池、各种圆柱型电池、无线通讯电池、便携式DVD电池、CD和MP3播放器电池、平板电脑电池等…
                </br>
                汽车启动用铅酸蓄电池、固定型铅酸蓄电池、小型阀控密封铅酸蓄电池…
                </br>
                动力二次电池、动力车用电池、电动道路车车用电池、电动工具用电池、混合动力车用电池…
                </br>
              </p>
              <h4 style="color: rgb(20, 97, 180); ">&nbsp;&nbsp;&nbsp;&nbsp;运输安全测试服务</h4>
              <p class="battery-p1" style="padding: 0 15px;">
                电池测试项目 Battery Testing Items 
                </br>
                环境测试 Environmental testing
                </br>
                高度模拟 Low pressure 
                </br>
                温度循环 Temperature cycling 
                </br>
                热滥用 Thermal abuse 
                </br>
                电气测试 额定容量 Rated capacity 
                </br>
                放电性能 Discharge performance 
                </br>
                过度放电 Over discharge 
                </br>
                过度充电 Over charge 
                </br>
                强迫放电 Forced discharge 
                </br>
                重物冲击测试 Impact
                </br>
                高速充电 High-rate charging 
                </br>
                外部短路 External short circuit
                </br>
                耐久寿命 Endurance 
                </br>
                荷电保持和恢复 Charge relenition and recovery 
                </br>
                内阻 Internal resistance 
                </br>
                机械测试 Environmental testing 
                </br>
                震动测试 Vibration 
                </br>
                机械冲击测试 Mechanical shock
                </br>
                自由跌落测试 Free fall 
                </br>
                挤压测试 Crush 
                </br>
                静电放电测试 Electrostatic discharge
                </br>
                电磁兼容测试 EMC testing
                </br>
                电池电化学分析 Electrochemical analysis 
                </br>
                电池材料特性分析 Battery materials analysis
                </br>
                </br>
              </p>
              <p class="battery-p2">
                来源：admin &nbsp; 发布时间：2020-06-25 &nbsp; 15:29
              </p>
            </el-drawer>
          </div>
          <div class="battery2">
            <el-button @click="innerDrawer2 = true">小分子团水检测</el-button>
            <el-drawer
              title="小分子团水检测"
              :append-to-body="true"
              :before-close="handleClose"
              :visible.sync="innerDrawer2">
              <h4>
                <img src="../assets/jc2.png" style="width: 100%; height: 150px" />
              </h4>
              <h4 style="color: rgb(20, 97, 180); ">&nbsp;&nbsp;&nbsp;&nbsp;检测方式：</h4>
              <p class="battery-p3" style="padding: 0 15px;">
                目前检测水分子团大小的方式只有一个，那就是“核磁共振”NMR（'⁷O—NMR 技术，这种技术是通过测定水的振动频率的半幅宽度（以赫兹 Hz 表示）来测定水分子团的大小。Hz 值越大表示水分子团越大，水的质量越差；Hz 值越小说明水分子团越小，水的质量越好
                </br>
              </p>
              <h4 style="color: rgb(20, 97, 180); ">&nbsp;&nbsp;&nbsp;&nbsp;小分子团水检测指标：半幅宽</h4>
              <p class="battery-p1" style="padding: 0 15px 20px 15px;">
                小分子团水的半幅频宽低于90Hz，平常的水半幅频宽在140-150Hz ,以此为小分子团水的检测依据。
                </br>
                小分子团水能通过人体细胞上2纳米的离子通道，进入细胞核和DNA,活化细胞酶组织，融化粘稠度高的血脂，溶解血液中的凝块，解酸排毒，清除各种重金属、亚硝酸盐、化学残留等。
                </br>
                <div height="10px"></div>
              </p>
              <p class="battery-p2">
                来源：admin &nbsp; 发布时间：2020-11-06 &nbsp; 15:29
              </p>
            </el-drawer>
          </div>
            <div class="battery3">
                <el-button @click="innerDrawer3 = true">半导体材料检测</el-button>
                <el-drawer
                  title="半导体材料检测"
                  :append-to-body="true"
                  :before-close="handleClose"
                  :visible.sync="innerDrawer3"
                >
                  <h4>
                    <img src="../assets/bdt1.webp" style="width: 100%; height: 150px" />
                  </h4>
                  <h4 style="color: rgb(20, 97, 180); ">&nbsp;&nbsp;&nbsp;&nbsp;常见半导体材料检测种类</h4>
                  <p class="battery-p3" style="padding: 0 15px;">
                    1、湿电子化学品检测种类：酸碱类、蚀刻类、溶剂类
                    </br>
                    2、光刻胶及配套试剂检测种类：光刻胶、负胶显影液、负胶漂洗液、负胶显影漂洗液、正胶显影液正胶稀释剂、边胶清洗剂、负胶剥离液、正胶剥离液等。
                    </br>
                    3、电池材料检测种类：负极材料、正极材料、电解液、电池/电解液添加剂、电池隔膜
                    </br>
                    4、电子元器件化学品检测种类：硝酸铋、硫酸铝、硝酸铝、硝酸钾、溴化钙、重铬酸铵、重络化钼、氯化、三氯化梯、磷酸、硅酸钾钠、硅铝、硫酸镁、硝酸铜、硝酬锶、氟化氢铵、碳酸、氧化销、氟化镁、锐酸钠、氧化擦、氧化钢等。
                    </br>
                    5、电子工业用气体检测种类：甲烷、三氯化硼、三氧化氩、六氟化硫、八氧环丁烷、六氟乙烷、四氟化碳、氯化氢、一氧化碳、笑气、硅烷等。
                    </br>
                    6、印刷电子化学品检测种类：印刷线路板材料及配套化学品、电子油墨、丝网印刷材料等。
                    </br>
                    7、电子胶类检测种类：SMT贴片红胶、LED贴片硅胶、UV胶、AB胶、填充胶、密封胶、导电银胶、硅胶等。
                    </br>
                    8、电子级水检测种类：超纯水、纯化水等。
                    </br>
                    9、其他电子材料检测种类：CMP抛光材料、靶材、导电录合物、液晶聚合物、聚酯薄膜、抗静电材料、抗蚀剂、封装材料、LED/OLED材料、发光材料、光学薄膜、平板膜、TFT-LCD面板及模组构成材料、电子纸、硅材料、太阳能电池膜等。
                    </br>
                  </p>
                  <h4 style="color: rgb(20, 97, 180); ">&nbsp;&nbsp;&nbsp;&nbsp;检测项目</h4>
                  <p class="battery-p3" style="padding: 0 15px;">
                    电学性能、光学性能、限用物质等
                    </br>
                    电学性能：电阻率、霍尔系数、磁阻等性能
                    </br>
                    光学性能：器光电导、光吸收等性能。
                    </br>
                    半导体材料的关键性能检测指标主要为禁带宽度、电阻率、载流子迁移率、非平衡载流子寿命、位错密度等。 
                    </br>
                  </p>
                  <h4 style="color: rgb(20, 97, 180); ">&nbsp;&nbsp;&nbsp;&nbsp;半导体检测标准</h4>
                  <p class="battery-p1" style="padding: 0 15px 20px 15px;">
                    1、标准号：GB3859-1983
                    </br>
                    标准名称：半导体电力变流器
                    </br>
                    标准状态：废止
                    </br>
                    标准类型分类：国家标准>>国家标准
                    </br>
                    GBCCS分类：电工>>输变电设备
                    </br>
                    2、标准号：SJ/T11395-2009
                    </br>
                    标准名称：半导体照明术语
                    </br>
                    标准状态：有效
                    </br>
                    标准类型分类：军工行业标准>>电子行业标准
                    </br>
                  </p>
                  <p class="battery-p2">
                    来源：admin &nbsp; 发布时间：2021-10-15 &nbsp; 15:29
                  </p>
                </el-drawer>
            </div>
            </el-drawer>

            <el-button
              @click="drawer2 = true"
              type="primary"
              round
              style="margin-left: 5px">
              科研动态
          </el-button>
          <el-drawer :visible.sync="drawer2" direction="ltr" size="500px">
            <img src="../assets/jc1.png" style="width: 100%; height: 350px" />
            <div class="battery4">
              <el-button @click="innerDrawer4 = true">多肽模拟计算</el-button>
              <el-drawer
                title="多肽模拟计算"
                :append-to-body="true"
                :before-close="handleClose"
                :visible.sync="innerDrawer4"
              >
                <img src="../assets/ky1.png" style="width: 100%; height: 250px" />
                <p class="battery-p1" style="padding: 0 15px;">
                  实验中发现两个多肽协同发挥作用，能够抑制李斯特氏菌的生长，单独作用没有抑菌活性，推测两个多肽协同作用于细胞膜。想通过分子动力学模拟，分析这两个多肽是如何协同作用的，是否插入到细菌的细胞膜从而发挥抑菌作用，然后主动和我们沟通确认计算需求。
                  </br>
                  &nbsp;
                </p>
                <p class="battery-p2">
                    来源：admin &nbsp; 发布时间：2023-12-15 &nbsp; 15:29
                  </p>
              </el-drawer>
            </div>
            <div class="battery5">
              <el-button @click="innerDrawer5 = true">分子模拟</el-button>
              <el-drawer
                title="分子模拟"
                :append-to-body="true"
                :before-close="handleClose"
                :visible.sync="innerDrawer5"
              >
                <img src="../assets/ky2.png" style="width: 100%; height: 250px" />
                <p class="battery-p1" style="padding: 0 15px;">
                  探究没食子酸、儿茶素、金丝桃苷、槲皮苷、积雪草酸、齐墩果酸、熊果酸、金丝桃苷、科罗索酸、α-淀粉酶、α-葡萄糖苷酶、胰脂肪酶、胆固醇脂酶之间的相互作用图，包括小分子与受体蛋白的结合位点，以什么方式结合在蛋白质的哪一个氨基酸上。能够得到活性成分与相应酶的结合位点的氨基酸组成，以及结合的方式。
                  </br>
                  &nbsp;
                </p>
                <p class="battery-p2">
                    来源：admin &nbsp; 发布时间：2023-12-21 &nbsp; 15:29
                  </p>
              </el-drawer>
            </div>
          </el-drawer>
        </el-drawer>
      </div>
      <div style="width: 15px;"></div>
    </section>
    <div class="index">
      <div class="lunbo" >
        <!-- 轮播 -->
        <el-carousel height="450px">
          <el-carousel-item>
              <img src="../assets/222.jpg" width="100%" height="450px" />
          </el-carousel-item>
          <el-carousel-item>
              <img src="../assets/111.jpg" width="100%" height="450px" />
          </el-carousel-item>
          <el-carousel-item>
              <img src="../assets/333.jpg" width="100%" height="450px" />
          </el-carousel-item>
        </el-carousel>
      </div>
    </div>
    <div class="indexserve">
      <h1 class="indexAtitle">SERVICE ITEMS</h1>
      <h2 class="indexBtitle">服务项目</h2>
      <ul>
        <li>
          <img src="../assets/S1.jpg" />
          <h5>认证检测</h5>
          <div class="smalllink">
            <RouterLink to='/Introduce'>国际认证</RouterLink>
          </div>
        </li>
        <li>
          <img src="../assets/S2.jpg" />
          <h5>体系认证</h5>
          <div class="smalllink">
            <RouterLink to='/Quality'>质量管理体系</RouterLink>
          </div>
        </li>
        <li>
          <img src="../assets/S3.jpg" />
          <h5>推荐方案</h5>
          <div class="smalllink">
            <RouterLink to='/Text'>认证检测</RouterLink>
          </div>
        </li>
        <li>
          <img src="../assets/S4.jpg" />
          <h5>认证流程</h5>
          <div class="smalllink">
            <el-link type="info" :underline="false" @click="dialogVisible = true">安全流程图</el-link>
            <el-dialog
              title="安全流程图"
              :visible.sync="dialogVisible"
              width="80%"
              :before-close="handleClose">
                <img src="../assets/liuchen.png" style="width:80%;height:80%"/>
              </el-dialog>
          </div>
        </li>
      </ul>
    </div>
    <el-dialog
    title="查询结果"
    :visible.sync="searchDialogVisible"
    width="50%"
    class="search-el-dialog"
    top="0"
    :before-close="handleClose">
      <el-row class="bordered-row">
        <el-col >申请公司：{{this.responseData.cName}}</el-col>
        <div class="vertical-line"></div>
        <el-col >编号：{{this.responseData.cCode}}</el-col>
      </el-row>
      <el-row class="bordered-row">
        <el-col>型号：{{this.responseData.cModel}}</el-col>
        <div class="vertical-line"></div>
        <el-col >规格：{{this.responseData.cSpecifications}}</el-col>
      </el-row>
      <el-row class="bordered-row">
        <el-col >发证日期：{{this.responseData.cIssuanceTime}}</el-col>
        <div class="vertical-line"></div>
        <el-col >证书截止日期：{{this.responseData.cEndTime}}</el-col>
      </el-row>
      <div style="height: 15px;"></div>
      <el-carousel class="search-horse-race-lamp" :interval="5000">
        <el-carousel-item v-for="item in carouselSize" :key="item">
          <img class="logdin-img" :src="getImageUrl(item)"></img>
        </el-carousel-item>
      </el-carousel>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="searchDialogVisible = false">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import axios from 'axios';
export default {
  data() {
    return {
      drawer: false,
      drawer2:false,
      drawer3:false,
      innerDrawer1: false,
      innerDrawer2: false,
      innerDrawer3: false,
      innerDrawer4: false,
      innerDrawer5: false,
      input: "",
      activeIndex: '1',
      dialogVisible: false,
      searchDialogVisible: false,
      responseData:[],
      carouselSize: 0
    };
  },
  methods: {
    handleClose(done) {
      done();
    },
    //根据编号查询
    searchByNumber(){
      if(this.input != null){
        const config = {
          headers: {
            'code': this.input
          }
        };
        axios.get('http://120.78.170.111:38080/webpage/certificate/code', config).then(response => {
          this.responseData = response.data.data;
          this.carouselSize = this.responseData.cFileName.split(',').length;
          if(this.responseData == null){
            alert("请输入正确的编号！");
            return;
          }
          this.searchDialogVisible = true;
        }).catch(error => {
          console.error('发生错误：', error);
        });
      }
    },
    getImageUrl(index) {
      const baseUrl = 'https://xinjinr.oss-cn-shenzhen.aliyuncs.com/'; // 基础地址
      var myArray = this.responseData.cFileName.split(',');
      return baseUrl + myArray[index-1];
    },
  },
};
</script>
